export const fieldsConfig = [
  // 🔹 Company Name
  {
    name: "company_name",
    label: "Company Name",
    type: "text",
    required: true,
  },

  // 🔹 Company Logo
  {
    name: "company_url",
    label: "Company Logo",
    type: "file",
    required: false,
    maxSizeMB: 10,        // max allowed size
    convertSizeKB: 20,   // final compressed target size
    acceptedTypes: ["image/jpeg", "image/png", "image/webp"]
  },

  // 🔹 Company Website URL
  {
    name: "company_site_url",
    label: "Company Website URL",
    type: "text",
    required: false,
  },

  // 🔹 Company Address
  {
    name: "company_address",
    label: "Company Address",
    type: "text",
    required: false,
  },

  // 🔹 Country (API Select)
  {
    name: "country_directory_fid",
    label: "Country",
    type: "select",
    required: false,
    is_api_data: true,
    optionsKey: "countries",          // must match dependenciesLoader return key
    optionLabel: "country_name",      // adjust if your API uses different field
  },

  // 🔹 City
  {
    name: "city",
    label: "City",
    type: "text",
    required: false,
  },

  // 🔹 GST Number
  {
    name: "gst_number",
    label: "GST Number",
    type: "text",
    required: false,
  },

  // 🔹 Owner (API Select)
  {
    name: "owner_fid",
    label: "Owner",
    type: "select",
    required: false,
    is_api_data: true,
    optionsKey: "clients",             // must match dependenciesLoader return key
    optionLabel: "client_name",        // adjust based on your API
  },

 
];